import { render, staticRenderFns } from "./TaskDocuments.vue?vue&type=template&id=30b655ca"
import script from "./TaskDocuments.vue?vue&type=script&lang=js"
export * from "./TaskDocuments.vue?vue&type=script&lang=js"
import style0 from "./TaskDocuments.vue?vue&type=style&index=0&id=30b655ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports